import type { UseModalOptions, VueFinalModal } from 'vue-final-modal'
import { useModal } from 'vue-final-modal'
import ModalManager from './components/modal/ModalManager.vue'

export const useCustomModal = (
  useModalParams: UseModalOptions<typeof ModalManager & typeof VueFinalModal>,
) => {
  return useModal({ component: ModalManager, ...useModalParams })
}
